<template lang="html">
  <div class="mapSeek">
      <el-select
        class="inpLoc"
        v-model="keyword"
        filterable
        remote
        reserve-keyword
        placeholder="输入所在地点"
        :remote-method="locSeek"
        @change="locSelect"
        :loading="loading">
        <el-option
          v-for="item in locationArr"
          :key="item.name"
          :label="item.name"
          :value="item.name">
          <div style="float: left">{{ item.name }}</div>
          <div style="float: right; color: #999999; font-size: 13px">{{ item.district }}</div>
        </el-option>
      </el-select>
  </div>

</template>

<script>
export default {
    name:'mapSeek',
    props:['paramsKey','preWord','sort'],
    data(){
        return{
             locationArr:[],
             locationMap:{},
             keyword:'',
             params:{
                 x:'',
                 y:'',
                 text:'',
                 adress:''
             }
        }
    },
    watch:{
        preWord:function(e){
           this.keyword = e;
        }
    },
    methods:{
        locSeek:function(query){
            let vues = this;
            if(query){
                vues.Autocomplete.search(query,function(status,res){
                    console.log(res);
                    vues.locationArr = res.tips;
                    var tempMap = {};
                    res.tips.forEach(item => {
                        tempMap[item.name] = item;
                    });
                    vues.locationMap = tempMap;
                })
            }
        },
        locSelect:function(e){
            var vues = this;
            if(e){
                var eDat = vues.locationMap[e];
                this.Geocoder.getLocation(eDat.district,function(status,res){
                     var unFormate = res.geocodes[0].location;
                     // vues.params.x = unFormate.lat + 0.047734999999995864;
                     // vues.params.y = unFormate.lng - 0.12048800000000881;
                     vues.params.x = unFormate.lat;
                     vues.params.y = unFormate.lng;
                     vues.params.text = eDat.name;
                     vues.params.address = eDat.district;

                     vues.$emit('mapChange',{
                          data:vues.params,
                          sort:vues.sort,
                          paramsKey:vues.paramsKey
                     });
                })
            }


        },
    },
    created:function(){
        var vues = this;
        var autoOptions = {
          city: '北京'
        }
        AMap.plugin('AMap.PlaceSearch', function(autoOptions){
            vues.Autocomplete = new AMap.Autocomplete();
            vues.Geocoder = new AMap.Geocoder();
        })

        if(this.preWord){
            this.keyword = this.preWord;
        }
    }
}
</script>

<style lang="css" scoped>

.inpLoc{
    width: 420px;
}

.mapSeek{
    display: inline-block;
}

</style>



// WEBPACK FOOTER //
// mapSeek.vue?4c7a8dc8